export default __webpack_public_path__ + "static/media/button-spinner-gray.05a82b80.svg";